<template>
  <el-dialog class="dialog" width="400px" :visible.sync="hintVisible">
    <template #title>
      <div class="hint-title">提示</div>
    </template>
    <template #default>
      <div class="hint-content">
        {{ content }}
      </div>
    </template>
    <template #footer>
      <div :class="footerCls">
        <el-button class="button" @click="closeHint">我知道了</el-button>
        <el-button v-if="principal" type="primary" @click="linkTo">立即签署</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import { Dialog, Button } from 'element-ui';
import classNames from 'classnames';
import router from '@/router';

Vue.use(Dialog);
Vue.use(Button);

export default {
  name: 'agreementConfirm',
  data() {
    return {
      hintVisible: false,
      principal: false,
      content: '',
      redirectUrl: ''
    };
  },
  computed: {
    footerCls() {
      const { principal } = this;
      return classNames('hint-footer', { principal });
    }
  },
  methods: {
    openHint() {
      this.hintVisible = true;
    },
    closeHint() {
      this.hintVisible = false;
      this.redirectUrl && router.push(this.redirectUrl);
    },
    linkTo() {
      const { id } = this;
      const reg = new RegExp('^\\/agreement\\/' + id + '$');
      !reg.test(router.history.current.path) && router.push(`/agreement/${id}`);
      this.hintVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog {
  width: 100%;

  /deep/.el-dialog__headerbtn {
    display: block;
  }

  .hint-title {
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    color: #242424;
  }

  /deep/.el-dialog__body {
    padding: 0;
  }

  .hint-content {
    padding: 0 49px;
    text-align: center;
    line-height: 24px;
    color: #242424;
  }

  .hint-footer {
    display: flex;
    justify-content: center;
    padding: 0 49px;

    &.principal {
      justify-content: space-between;
    }

    .button {
      color: #1e8dff;
      background: #fff;
    }
  }
}
</style>
